import React, { useState } from "react";
import { Form, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AddEmail(){
    const API_URL = BASE_URL+"/addemail";
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const hostName = formData.get("hostname");
        const email = formData.get("email");
        const password = formData.get("password");
        const port = formData.get("port");
        
        if(!hostName || !email || !password || !port){
            toast.error("All fields are required!");
        }
        else{
            const data = {
                Port: port,
                HostName: hostName,
                Email: email,
                Password: password
            }
            axios.post(API_URL, data, {
                headers: {
                    "Authorization": apiKey,
                    "Content-Type": "application/json"
                }
            })
            .then(
                res => {
                    if(res.data.message == "Email already exist"){
                        toast.error("This email already exist!");
                    }
                    else{
                        navigate("/emails/check-emails")
                    }
                }
            )
            .catch(
                error => {
                    toast.error("Email Credentials Invalid!");
                }
            )
        }
    }
    return(
        <div className="container">
            <ToastContainer />
            <h2>Add New Email</h2>
            <br />
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <input type="text" placeholder="Enter Host Name" className="form-control" name="hostname" required/>
                    </div>
                    <div className="col-sm-6">
                        <select className="form-control" name="port" required>
                            <option disabled selected>Select Port</option>
                            <option value="25">25</option>
                            <option value="465">465</option>
                            <option value="587">587</option>
                        </select>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <input type="email" placeholder="Enter Email Here" className="form-control" name="email" required/>
                    </div>
                    <div className="col-sm-6">
                        <input type="password" placeholder="Enter Password Here" className="form-control" id="inputPassword5" name="password" required/>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <button className="btn btn-primary">Add Email</button>
                    </div>
                </div>
            </form>
        </div>
    );
}